export const MOS = "mos";
export type MOS = typeof MOS;

export const REQUEST_MOS_RESYNC_PLAYLIST = `${MOS}/requestMosResyncPlaylist`;
export type REQUEST_MOS_RESYNC_PLAYLIST = typeof REQUEST_MOS_RESYNC_PLAYLIST;

export const REQUEST_GET_MOS_STATUS = `${MOS}/requestGetMosStatus`;
export type REQUEST_GET_MOS_STATUS = typeof REQUEST_GET_MOS_STATUS;

export const RECEIVE_MOS_STATUS = `${MOS}/receiveMosStatus`;
export type RECEIVE_MOS_STATUS = typeof RECEIVE_MOS_STATUS;

export const REQUEST_TOGGLE_MOS_AUTO_FETCH = `${MOS}/requestToggleMosAutoFetch`;
export type REQUEST_TOGGLE_MOS_AUTO_FETCH = typeof REQUEST_TOGGLE_MOS_AUTO_FETCH;

export type MosStateType = {
	connected: boolean;
	autoFetch: boolean;
	statusLoading: boolean;
};
